import React from "react";
import { motion } from "framer-motion";

const PLACEMENT_URL =
  "https://customer-assets.emergentagent.com/job_future-tech-site-6/artifacts/l8c7phwz_MAR_BACKSIDE%20copy.png";

const PlacementBanner = () => {
  return (
    <section
      id="placements"
      className="relative py-10 md:py-16 lg:py-20 border-t border-white/5 overflow-hidden"
      data-testid="placement-banner-section"
    >
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[70%] h-[400px] rounded-full bg-[#39FF14]/[0.05] blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-[#00E5FF]/[0.04] blur-3xl pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="absolute -inset-1 bg-gradient-to-br from-[#39FF14]/30 via-transparent to-[#00E5FF]/35 rounded-3xl blur-xl opacity-80" />
          <div className="relative rounded-2xl overflow-hidden border border-[#39FF14]/25 bg-[#07090f]">
            <img
              src={PLACEMENT_URL}
              alt=""
              loading="lazy"
              className="relative block w-full h-auto object-contain"
              data-testid="placement-banner-image"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PlacementBanner;
